module.exports = __webpack_public_path__ + "094b46f5be242a35464ec4bb431188e6.svg";